export default {
  name: 'dashify:StackedCartesian',
  title: 'Stacked Cartesian',
  owner: 'System',
  solution: '',
  tags: ['data', 'visualization', 'cartesian', 'line', 'area', 'bar', 'column'],
  updatedAt: 'Jan 12, 2024, 11:19 AM',
  createdAt: 'Jan 12, 2024, 11:19 AM',
  spec: {
    props: {
      highchartsConfig: {},
    },
    defaults: {
      highchartsConfig: {
        plotOptions: {
          column: {
            borderWidth: 2,
            borderColor: 'var(--control-bg-weak)',
          },
          series: {
            stacking: 'normal',
          },
        },
      },
    },
    view: [
      [
        'div',
        {
          '.': 'grow',
        },
        [['dashify:Cartesian', '/${ $defaultsDeep({}, props, defaults) }']],
      ],
    ],
  },
};
